export const useAllParagraphs = (quill: any) => {
  // Just gent the number of unique paragraph indexes
  if (quill == undefined) return [];

  const lines = quill.getLines();

  let allParagraphs = lines.filter((line: any) => {
    const domNode = line.domNode;

    // Get the plain text inside ofthe dom node
    const text = domNode.innerText;

    if (text.trim().length == 0) return false;

    // Confirm with Hedi if this should remain included
    if (text.trim().replace(/[^a-zA-Z]/g, "").length === 0) return false;

    if (text.trim().length < 5) return false;

    return true;
  });

  let start = 0;

  for (const paragraph of allParagraphs) {
    paragraph.start = start;
    paragraph.end = start + paragraph.cache.length;
    start += paragraph.cache.length;
  }

  return allParagraphs;
};
export const useAllHeaderParagraphs = (
  quill: any,
  headerAttributes: string[]
) => {
  const paragraphs = useAllParagraphs(quill);

  return paragraphs.filter((paragraph: any) => {
    for (const attribute of headerAttributes) {
      // Check if the paragraph has [attribute] as an attribute on the domNode
      const domNode = paragraph.domNode;
      const hasAttribute = domNode.hasAttribute(attribute);

      if (hasAttribute) {
        return true;
      }
    }

    return false;
  });
};

export const useAllBodyParagraphs = (
  quill: any,
  paragraphPositionsData: ParagraphPositionData[]
) => {
  const paragraphs = useAllParagraphs(quill);

  let bodyParagraphs = [] as { index: number; data: any }[];

  let index = 0;

  for (const paragraph of paragraphs) {
    // Check if the paragraph has [attribute] as an attribute on the domNode
    const domNode = paragraph.domNode;

    bodyParagraphs.push({
      index: index,
      data: paragraph,
    });
    index++;
  }

  const bibliographyIndex = bodyParagraphs.findIndex((paragraph) => {
    let text = paragraph.data.domNode.innerText.trim().toLowerCase();
    // strip any hidden charactes like tabs and newlines
    text = text.replace(/[^a-z0-9\s]/g, "").trim();

    if (["bibliography", "works cited", "works consulted"].includes(text)) {
      return true;
    }

    return false;
  });

  if (bibliographyIndex >= 0) {
    bodyParagraphs = bodyParagraphs.slice(0, bibliographyIndex);
  }

  const numParagraphPositions = paragraphPositionsData.length;
  const startingIndex = bodyParagraphs.length - numParagraphPositions;

  // slicer off everything before the starting index
  bodyParagraphs = bodyParagraphs.slice(startingIndex);

  return bodyParagraphs;
};
